import { useState } from "react";
import { CurrencyContext } from "../context";

let defaultValue = {
  symbol: "C$",
  //label: "Canadian Dollar",
  label: "CAD",
  value: "CAD",
};

export const currencyList = [
  defaultValue,
  /*  {
     symbol: "US$",
     label: "USD",
     //label: "US Dollar",
     value: "USD",
   }, */
];

const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(defaultValue);

  const setCurrencyCode = (data) => {
    setCurrency(data);
  };

  const convertCurrency = (price, symbol) => {
    if (symbol) {
      return `${symbol} ${price}`;
    }
    return `${currency?.symbol} ${price}`;
  };

  return (
    <CurrencyContext.Provider
      value={{ currency, setCurrencyCode, convertCurrency }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyProvider;
